<!-- <p>product-generic-grid works!</p> -->

<!-- No results -->
<div class="product-level-1 container-fluid p0" *ngIf="(displayNoResults && (products.length === 0 || (!allowNotAvailable && areAllProductsUnavailable)))" style="color: #5A5A5A; font-size: 20px;" data-qa="prd-gnrc-grd">
    <div [ngClass]="{'no-results': true, 'search-no-results': searchNoResults}" *ngIf="showGrid">
        <div [innerHTML]="noResults"></div>
        <div [innerHTML]="aisleHTML"></div>
    </div>
</div>

<!-- Product grid -->
<div class="product-level-4" *ngIf="(showGrid) && (products.length > 0) && (allowNotAvailable || !areAllProductsUnavailable)">
    <sort-by *ngIf="(products.length > 0) && hasSort && loadSort()"
        [sortRules]='sortRules'
        [activeSortRule]='activeSortRule'
        (activeSortRuleEmitter)='activeSortRuleEmitter($event)'
        [ngClass]="{'bia-sort': biaSort}">
    </sort-by>


    <div [ngClass]="{'pc-grid-contained':isCalledByRightDrawerOrOneTimeAddFlow}" class="pc-grid w-100 gutters-items-v2 product-grid-v2 product-card-grid">

        <ng-container *ngFor="let product of products; let i = index;">
            @let showCrossSell = hasCrossSell === true && (fullWidthIndices.has(i) || i+1 === products.length);
            @let rowIndex = fullWidthIndices.get(i);
            @let showGridZoneRow = gridComponents?.size > 0 && gridComponents.has(rowIndex);
            @let crossSellPlaceholderId = 'cross-sell-placeholder-'+product.id;
            <div class="section-heading product-group sort-by-aisle pc__col-full-width" *ngIf="product.isGroupSplit && isAisleSort && loadSort()">
                <h2>{{product[groupByField]}}</h2>
            </div>

            <product-item-al-v2 
                [ngClass] = "hasCrossSell ? crossSellPlaceholderId : ''"
                [(isRestricted)]="unAttendDeliveryFlag"
                [data]="product"
                [offers] = "dataOffers"
                [calledBy]="calledBy"
                data-qa="prd-itm"
                [configObj]="configObj"
                class="pc-grid-prdItem h-100"
                [isCalledByRightDrawerOrOneTimeAddFlow]="isCalledByRightDrawerOrOneTimeAddFlow">
            </product-item-al-v2>

            <ng-container *ngIf="showCrossSell === true">
                <div class="pc__col-full-width cross-sell-row">

                </div>
            </ng-container>
            <ng-container *ngIf="showGridZoneRow === true && showGridZoneComponents === true">
                @let componentType = dynamicGridHasFacets ? 'gridRowWithFacets' : 'gridRow';
                <zone class="pc__col-full-width"
                    [componentType]="componentType"
                    [componentData]="gridComponents.get(rowIndex)"
                    [zoneId]="'gridZoneContent'+rowIndex"/>
            </ng-container>

        </ng-container>
        <div class="pc__col-full-width"></div>
    </div>

    <!-- AFB polite for removed products -->
    <div aria-live="polite" aria-atomic="true" class="visuallyhidden">{{afbEvent}}</div>

    <div class="row justify-content-center" *ngIf="(component.pagination.load_type === 'loadmore') && !isServerGridLoading && (products.length < productsSecondary.length || (isOneTimeAddFlow && searchKeyword?.length>0 && nextPageToken))">
        <button role="button" class="bloom-load-button btn btn-secondary btn-xl mt-3" (click)="loadMoreProducts('grid_button');">Load more</button>  
    </div>

    <div id="searchGridLoading" class="loading-div-medium" *ngIf="isServerGridLoading">
        <div class="loading-spinner">
            <div class="large progress" alt="Loading..."><div class="prog1"><div class="prog2"></div></div></div>
        </div>
    </div>
    
    <div class="load-more-container" *ngIf="hasServerSideLoadMore && !isServerGridLoading">
        <button class="btn btn-default btn-secondary load-more" role="button" (click)="loadMoreProductsServerSide('grid_button');">Load more</button>
    </div>
</div>

